// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__qamOJ","topBottomGutter":"Layout_topBottomGutter__JtI8i"};